import { IResortTrailmapPage } from 'api/resort/types';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import {
  formatDateFromStr,
  SHORT_MONTH_WITH_YEAR_DATE_FORMAT,
} from 'util/formatDate';
import { SnowUnit } from 'components/blocks/Unit';
import styles from './styles.module.scss';
import { SectionHeader } from '../SectionHeader';

interface Props {
  trailmap: IResortTrailmapPage;
  mountainOverview: { dangerouslySetInnerHTML: { __html: string; }; }
  isPermanentlyClosed:boolean;
  annualSnowfall?: number;
}

export const WhenToGoSection = ({
  trailmap, mountainOverview, isPermanentlyClosed, annualSnowfall,
}:Props) => {
  const { t } = useOTSTranslation('common');

  return (
    <section id={styles.whenToGo}>
      <SectionHeader title={t('resort.overview.importantDates')} />
      <div>
        {trailmap.dates.projectedOpening ? (
          <div>
            <h4>{t('region.openDates.projectedDate')}</h4>
            <p>{isPermanentlyClosed ? t('common.na') : formatDateFromStr(trailmap.dates.projectedOpening, SHORT_MONTH_WITH_YEAR_DATE_FORMAT)}</p>
          </div>
        ) : null}
        {trailmap.dates.projectedClosing ? (
          <div>
            <h4>{t('region.closingDates.projectedDate')}</h4>
            <p>{isPermanentlyClosed ? t('common.na') : formatDateFromStr(trailmap.dates.projectedClosing, SHORT_MONTH_WITH_YEAR_DATE_FORMAT)}</p>
          </div>
        ) : null}
        {trailmap.dates.projectedDaysOpen ? (
          <div>
            <h4>{t('resort.overview.projectedDaysOpen')}</h4>
            <p>{trailmap.dates.projectedDaysOpen}</p>
          </div>
        ) : null}
        {trailmap.dates.daysOpenLastYear ? (
          <div>
            <h4>{t('resort.overview.daysOpenLastYear')}</h4>
            <p>{trailmap.dates.daysOpenLastYear}</p>
          </div>
        ) : null}
        {trailmap.dates.yearsOpen ? (
          <div>
            <h4>{t('resort.overview.yearsOpen')}</h4>
            <p>{trailmap.dates.yearsOpen}</p>
          </div>
        ) : null}
        {annualSnowfall ? (
          <div>
            <h4>{t('resort.overview.averageSnowfall')}</h4>
            <p>
              <SnowUnit values={annualSnowfall} />
            </p>
          </div>
        ) : null}
      </div>
      <SectionHeader description={mountainOverview} />
    </section>
  );
};
